export * from './oauth'
export * from './regexp'
export * from './navTypes'
export * from './message'
export * from './msgTypes'
export * from './imCustomMsgTypes'
export * from './time'
export * from './user'

/**
 * 1MB 对应的字节数
 */
export const MB_OF_BYTE = 1024 * 1024

/**
 * IM SDK 推送消息中 header.contentType 字段
 * 业务一般用 CUSTOMER 类型，对应的 content 用 TextMsg 类型
 */
export const IM_CONTENT_TYPE = {
  UNKNOW_CONTENT_TYPE: 0,
  TEXT: 1,
  PICTURE: 2,
  VOICE: 3,
  VIDEO: 4,
  FILE: 5,
  QUOTE: 6,
  RICH_TEXT: 7,
  CUSTOMER: 100,
}

/**
 * 语言映射常量
 * Language mapping constants
 *
 * 将英文语言标识映射为本地语言显示
 * Maps English language keys to native language display names
 */

export const LANGUAGE_DISPLAY_MAP = {
  'English': 'English',
  'Chinese': '中文',
  'Hindi': 'हिंदी',
  'Arabic': 'العربية',
  'Turkish': 'Türk dili',
  'French': 'Français',
  'Indonesia': 'Bahasa Indonesia',
  'Vietnamese': 'Tiếng Việt',
  'Thai': 'ไทย',
  'Korean': '한국인',
  'Japanese': '日本語',
  'Malay': 'Melayu',
  'Russian': 'Русский',
  'German': 'Deutsch',
  'Spanish': 'Español',
  'Portuguese': 'Português',
  'Italian': 'Italiano',
}

/**
 * 支持的语言列表
 * Supported language keys
 */
export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_DISPLAY_MAP)

/**
 * loveRoomStart 的 come_from 参数
 */
export const LIVE_ROOM_COME_FROM = {
	PRIVATE: 0,  //私聊页发起视频
	PERSONAL: 1,  //通过个人页发起视频
	MATCH: 2,  //通过匹配进入直播间
	MATCH_ANCHOR: 3,  //女主播收到弹窗进入直播间
	MATCH_ANCHOR_BACKGROUND: 5,  //女主播后台收到弹窗进入直播间
	LIVE_CAM: 7,  //liveCAM打定向视频
	VIDEO_LIST: 8,  //通过视频列表发起视频
	PAID_USER_LIST: 9,  //付费用户列表页面，定向电话，只有主播有
	CALL_LIST: 10, //通话记录页面，定向通话，只有主播有
	VIDEO_POP: 11, //通过视频弹窗发起定向
	VIDEO_RECOMMEND_ANCHOR: 12, //Deprecated: 假视频推荐定向
	NEW_USER_VIDEO_RECOMMEND: 13, //Deprecated: 新用户假视频弹窗
	LIVE_RECOMMEND: 15, //Deprecated: liveCAM匹配视频
	MSG_INSTEAD: 16, //回复代发消息弹窗
	PARTY_ROOM: 17, //来自语音房
	CARD: 18, //来自划卡（comlive）
	AUTO_AFTER_PAY: 19, // 来自支付成功后的自动拨打,复购转化测试需求添加：https://yidui-me.feishu.cn/wiki/VoUxwq2yNiLqyvkvdFJcEsQ3nAb
	PERSONAL_SIMULATE_VIDEO: 20, // 个人页模拟视频
	MSG_SIMULATE_VIDEO: 21, // 消息页模拟视频
	MSG_INDUCE_VIDEO: 22, // 消息页引导视频
	AMIGO_VIDEO: 23, // Amigo视频流
	QUICK_MATCH: 24, // 快速匹配
	MOMENT: 25, // 动态
	APPOINTMENT_CALLBACK: 26, // 预约回拨
	FAKE_VIDEO_CALL_STYLE: 27, // 假视频通话样式
	AI_COMMENT: 28, // AI回复动态引导弹窗
	SHOW_ROOM: 29, // 秀场转1v1
	FLOATING_SHOW_LIVE: 30, // 秀场小窗
	BACKPACK_CARD: 31, // 礼物背包
	MSG_CALL_CARD: 32, // 消息页卡片
	MSG_CALL_TIP: 33, // 消息页提示
	PAID_MATCH_ANCHOR_BACKGROUND: 51, //女主播后台收到付费弹窗进入直播间
}

/**
 * IM PAY_RESULT 消息中的 result_code 字段
 */
export const PAY_RESULT_CODE = {
  SUCCESS: 1,
  PENDING: 0,
  REFUNDED: 2,
  FAILED: 3,
}

/**
 * 视频通话兜底价格
 */
export const BOTTOM_LINE_PRICE = 80

/**
 * 服务端错误码
 */
export const SERVER_ERROR_CODE = {
  FORBIDDEN: 10001,                 // 当前用户被封禁，提示封禁原因
  INSUFFICIENT_COINS: 10004,        // 金币不足，提示充值
  NO_VIP: 10005,                    // 没有会员，提示购买会员
  REQUIRE_REAL_NAME: 10015,         // 需要实名认证或扫脸，跳转认证页面
  SYSTEM_MUTED: 10020,              // 被系统禁言(在随机匹配中如果收到这个错误码需中断随机匹配)
  INSUFFICIENT_INTIMACY: 31001,     // 拨打视频是，发起方亲密度不足，显示 HintDialog 弹窗
  EMPTY_BROADCAST_PENALTY: 70001,   // TODO:(这个错误码似乎不是空播惩罚，返回的提示信息是主播繁忙)主风控空播拦截，显示 Toast，如果来自匹配则停止匹配
  COMMON_ERROR: 500100,             // 通用错误，显示 Toast
  REJECT_PENALTY: 70002,            // 主播拒接被惩罚
}

/**
 * 会话列表类型常量
 */
export const CONVERSATION_TYPE = {
  NORMAL: 'normal',     // 普通会话
  STRANGER: 'stranger', // 陌生人会话
}
